export default "__VITE_ASSET__BAKu5cvw__"